import { ReactNode } from 'react'

export const stripMarkdown = (text: string): string => {
  const linkRegex = /\[(.*?)\][\[\(].*?[\]\)]/g

  return text.replace(linkRegex, '$1')
}

export const isText = (node: ReactNode) =>
  Array.isArray(node) && typeof node[0] === 'string'

export const isImageLink = (node: ReactNode) =>
  Array.isArray(node) && node.some(isImage)

export const isImage = (node: any) => {
  return (
    typeof node === 'object' &&
    node.hasOwnProperty('props') &&
    node.props.hasOwnProperty('src')
  )
}

export const isAnchorImage = (node: any) => {
  return (
    typeof node === 'object' &&
    node.hasOwnProperty('props') &&
    node.props.hasOwnProperty('href') &&
    node.props.children.some(isImage)
  )
}
